export const accountPreviewsQueryKey = () => ["previews", "accounts"] as const;
